import { Component, OnInit } from '@angular/core';
import { CommonMessageService } from 'src/app/services/common-message.service';
import { MasterDataService } from 'src/app/services/master-data.service';
import { BudgetCLientAssignmentModel, BudgetClientModel, BudgetReportModel, BudgetRole } from './budget.model';

@Component({
  selector: 'app-budget',
  templateUrl: './budget.component.html',
  styleUrls: ['./budget.component.css']
})
export class BudgetComponent implements OnInit {
  employeeList;
  financialList;
  reportList: BudgetReportModel;

  selectedFinancialYear;;
  selectedEmployee;
  distinctRoles;


  constructor(private masterDataService: MasterDataService,private commonMessageService:CommonMessageService) { }

  ngOnInit(): void {
    this.selectedFinancialYear = "";
    this.selectedEmployee = "";
    this.loadInitDetails();
  }
  loadInitDetails() {
    this.masterDataService.getFinancialYear()
      .subscribe(res => {
        this.financialList = res;
      });

    this.masterDataService.getPartners()
      .subscribe(res => {
        this.employeeList = res;
        console.log('employee list', this.employeeList);
      });
  }

  showExportToExcelButton = false;
  onViewReport() {
    if (this.selectedFinancialYear == null || this.selectedFinancialYear == undefined || this.selectedFinancialYear == ""
      || this.selectedEmployee == null || this.selectedEmployee == undefined || this.selectedEmployee == "")
       this.commonMessageService.swalAlertWithoutIcon('',"Please choose the values before pressing report");
    else {
      this.masterDataService.getBudgetReport(this.selectedFinancialYear.id, this.selectedEmployee.id,)
        .subscribe(res => {
          this.reportList = res;
          console.log('budget report response', this.reportList);
          if (this.reportList == null) {
            this.showExportToExcelButton = false;
             this.commonMessageService.swalAlertWithoutIcon('',"No Record Found.");

          } else {
            this.showExportToExcelButton = true;
            this.findDistinctRoles();
          }
        }, err => {
          this.reportList = null;
        })
    }
  }

  budgetOldExportToExcelClick() {
    this.masterDataService.getOldBudgetReportExcelToExport(this.selectedFinancialYear.id, this.selectedEmployee.id,)
      .subscribe((resp: any) => {
        const blob = new Blob([resp]); // you can change the type
        var downloadURL = window.URL.createObjectURL(blob);
        var link = document.createElement('a');
        link.href = downloadURL;
        link.download = "BudgetReport.xlsx";
        link.click();
      });
  }

  budgetNewExportToExcelClick() {
    this.masterDataService.getNewBudgetReportExcelToExport(this.selectedFinancialYear.id, this.selectedEmployee.id,)
      .subscribe((resp: any) => {
        const blob = new Blob([resp]); // you can change the type
        var downloadURL = window.URL.createObjectURL(blob);
        var link = document.createElement('a');
        link.href = downloadURL;
        link.download = "NewBudgetReport.xlsx";
        link.click();
      });
  }

  findDistinctRoles() {
    this.distinctRoles = this.reportList.clients[0].assignments[0].roles.map(({ role }) => role);
    console.log('distinct roles', this.distinctRoles);
    this.getBranchRowSpan();
  }
  getBranchRowSpan() {
    // const numberOfRows = this.reportList.clients.map(({ assignments }) => assignments.length).reduce((a) => { return a +1 })
    // console.log('total row count', numberOfRows);
    // return numberOfRows * 2;
    var count = 0;
    this.reportList.clients.map((res) => {
      res.assignments.map((res1) => {
        count++;
      });
    });
    return count;
  }


  // getAssignmentRoleOrdered(roles: BudgetRole[]) {
  //inside html
  // getAssignmentRoleOrdered(assignment.roles)
  //this code for role sequence
  //   let returnValue = [];
  //   console.log('disctince roles', this.distinctRoles);
  //   console.log('roles', roles);
  //   for (let i = 0; i < this.distinctRoles.length; i++) {
  //     for (let j = 0; j < roles.length; j++) {
  //       if (this.distinctRoles[i] == roles[j].role) {
  //         returnValue.push(roles[j]);
  //         break;
  //       }
  //     }
  //   }
  //   console.log('return value', returnValue);
  //   return returnValue;
  // }

  getTotalManDays(client: BudgetClientModel, roleValue: string) {
    const total = client.assignments.map(({ roles }) => roles).reduce((acc, it) => [...acc, ...it], [])
      .map(({ role, roleManDays }) => { return role == roleValue ? roleManDays : 0 }).reduce((a, b) => { return a + b });
    return total
  }
  getTotalCount(client: BudgetClientModel, roleValue: string) {
    const total = client.assignments.map(({ roles }) => roles).reduce((acc, it) => [...acc, ...it], [])
      .map(({ role, roleCount }) => { return role == roleValue ? roleCount : 0 }).reduce((a, b) => { return a + b });
    return total;
  }
  getTotalTotalManDays(client: BudgetClientModel, roleValue: string) {
    const total = client.assignments.map(({ roles }) => roles).reduce((acc, it) => [...acc, ...it], [])
      .map(({ role, roleTotalManDays }) => { return role == roleValue ? roleTotalManDays : 0 }).reduce((a, b) => { return a + b });
    return total;
  }
  getTotalTotalCost(client: BudgetClientModel, roleValue: string) {
    const total = client.assignments.map(({ roles }) => roles).reduce((acc, it) => [...acc, ...it], [])
      .map(({ role, roleTotalCost }) => { return role == roleValue ? roleTotalCost : 0 }).reduce((a, b) => { return a + b });
    return total;
  }
  getTotalBudget(client: BudgetClientModel) {
    const total = client.assignments.map(({ budgetCost }) => budgetCost).reduce((a, b) => a + b);
    return total;
  }
  getTotalFees(client: BudgetClientModel) {
    const total = client.assignments.map(({ fees }) => fees).reduce((a, b) => a + b);
    return total;
  }
  getTotalContribution(client: BudgetClientModel) {
    const total = client.assignments.map(({ contribution }) => contribution).reduce((a, b) => a + b);
    return total;
  }
  getTotalPercentage(client: BudgetClientModel) {
    const budgetCost = client.assignments.map(({ budgetCost }) => budgetCost).reduce((a, b) => a + b);
    const fee = client.assignments.map(({ fees }) => fees).reduce((a, b) => a + b);
    return (fee - budgetCost) / fee * 100;
  }

  getAllTotalManDays(roleValue: string) {
    const total = this.reportList.clients.map(({ assignments }) => assignments).reduce((acc, it) => [...acc, ...it], [])
      .map(({ roles }) => roles).reduce((acc, it) => [...acc, ...it], [])
      .map(({ role, roleManDays }) => { return role == roleValue ? roleManDays : 0 }).reduce((a, b) => { return a + b });
    return total;
  }
  getAllTotalCount(roleValue: string) {
    const total = this.reportList.clients.map(({ assignments }) => assignments).reduce((acc, it) => [...acc, ...it], [])
      .map(({ roles }) => roles).reduce((acc, it) => [...acc, ...it], [])
      .map(({ role, roleCount }) => { return role == roleValue ? roleCount : 0 }).reduce((a, b) => { return a + b });
    return total;
  }
  getAllTotalTotalManDays(roleValue: string) {
    const total = this.reportList.clients.map(({ assignments }) => assignments).reduce((acc, it) => [...acc, ...it], [])
      .map(({ roles }) => roles).reduce((acc, it) => [...acc, ...it], [])
      .map(({ role, roleTotalManDays }) => { return role == roleValue ? roleTotalManDays : 0 }).reduce((a, b) => { return a + b });
    return total;
  }
  getAllTotalTotalCost(roleValue: string) {
    const total = this.reportList.clients.map(({ assignments }) => assignments).reduce((acc, it) => [...acc, ...it], [])
      .map(({ roles }) => roles).reduce((acc, it) => [...acc, ...it], [])
      .map(({ role, roleTotalCost }) => { return role == roleValue ? roleTotalCost : 0 }).reduce((a, b) => { return a + b });
    return total;
  }
  getAllTotalBudget() {
    const total = this.reportList.clients.map(({ assignments }) => assignments).reduce((acc, it) => [...acc, ...it], [])
      .map(({ budgetCost }) => budgetCost).reduce((a, b) => a + b);
    return total;
  }
  getAllTotalFees() {
    const total = this.reportList.clients.map(({ assignments }) => assignments).reduce((acc, it) => [...acc, ...it], [])
      .map(({ fees }) => fees).reduce((a, b) => a + b);
    return total;
  }
  getAllTotalContribution() {
    const total = this.reportList.clients.map(({ assignments }) => assignments).reduce((acc, it) => [...acc, ...it], [])
      .map(({ contribution }) => contribution).reduce((a, b) => a + b);
    return total;
  }
  getAllTotalPercentage() {
    const budgetCost = this.reportList.clients.map(({ assignments }) => assignments).reduce((acc, it) => [...acc, ...it], [])
      .map(({ budgetCost }) => budgetCost).reduce((a, b) => a + b);
    const fee = this.reportList.clients.map(({ assignments }) => assignments).reduce((acc, it) => [...acc, ...it], [])
      .map(({ fees }) => fees).reduce((a, b) => a + b);
    return (fee - budgetCost) / fee * 100;
  }
}
